import { useEffect } from 'react';
import { WhatsAppWidget } from '../WhatsAppWidget';
import Forms from '../Form';
import { MainHeader } from '../MainHeader';
import { Map } from '../map';
import './styles.css';

export const ContactPage = () => {
  useEffect(() => {
    document.title = "Ruesevents Designs - Contact";
  }, []);

  return (
  <div className="page-shell contact-page">
    <MainHeader home={false} about={false} gallery={false} contact={true} />

    <section className="contact-heading-section">
      <div className="section-shell">
        <p className="section-kicker">Let's connect</p>
        <h1>Tell us what you're planning.</h1>
        <p>
          Share a little about your event and our team will get in touch to discuss how Ruesevents
          Designs can help bring it to life.
        </p>
      </div>
    </section>

    <section className="contact-main-section">
      <div className="section-shell contact-main-grid">
        <div className="contact-details-panel">
          <p className="section-kicker">Get in touch</p>
          <h2>We'd love to hear from you.</h2>
          <p>
            Whether you're planning a wedding, lobola celebration, birthday, corporate event or need
            floral styling, send us a message and let's start the conversation.
          </p>

          <div className="contact-detail-list">
            <div>
              <span>Call us</span>
              <a href="tel:+263784532559">+263 784 532 559</a>
              <a href="tel:+263775967763">+263 775 967 763</a>
              <a href="tel:+263716311137">+263 716 311 137</a>
            </div>
            <div>
              <span>Email us</span>
              <a href="mailto:info@ruesevents.co.zw">info@ruesevents.co.zw</a>
            </div>
            <div>
              <span>Visit us</span>
              <p>6 Trent Road, Harare, Zimbabwe</p>
            </div>
          </div>
        </div>

        <Forms />
      </div>
    </section>

    <Map />
      <WhatsAppWidget />
  </div>
  );
};
